import React from 'react';
import type { Card } from '@ctd/agent-contract';
import { CardFrame } from './card-frame';
import { MetricBlock, MetricValue } from './metric-block';
import style from '../style.module.scss';

export const ValueCard: React.FC<{
    card: Extract<Card, { shape: 'value' }>;
}> = ({ card }) => (
    <CardFrame card={card} size="sm">
        <div className={style.metrics}>
            {card.primary.map((metric) => (
                <MetricBlock key={metric.id} metric={metric} title={card.title}>
                    <MetricValue metric={metric} />
                </MetricBlock>
            ))}
        </div>
    </CardFrame>
);
